/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Pre_Render_Frame_Cache_Progress_StatusInputs */

const en_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generating frame cache ${i?.current}/${i?.total}`)
};

const fr_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Génération du cache d'images ${i?.current}/${i?.total}`)
};

const de_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generiere Frame-Cache ${i?.current}/${i?.total}`)
};

const it_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generazione della cache dei frame ${i?.current}/${i?.total}`)
};

const ru_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Создание кэша кадров ${i?.current}/${i?.total}`)
};

const es_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generando caché de fotogramas ${i?.current}/${i?.total}`)
};

const zh_cn2_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`生成帧缓存${i?.current}/${i?.total}`)
};

const ja_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレームキャッシュ${i?.current}/${i?.total}を生成しています`)
};

const hi_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ्रेम कैश जनरेट किया जा रहा है ${i?.current}/${i?.total}`)
};

const pt_pt2_pre_render_frame_cache_progress_status = /** @type {(inputs: Pre_Render_Frame_Cache_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerando cache de quadros ${i?.current}/${i?.total}`)
};

/**
* | output |
* | --- |
* | "Generating frame cache {current}/{total}" |
*
* @param {Pre_Render_Frame_Cache_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_progress_status = /** @type {((inputs: Pre_Render_Frame_Cache_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_pre_render_frame_cache_progress_status(inputs)
	if (locale === "de") return de_pre_render_frame_cache_progress_status(inputs)
	if (locale === "it") return it_pre_render_frame_cache_progress_status(inputs)
	if (locale === "ru") return ru_pre_render_frame_cache_progress_status(inputs)
	if (locale === "es") return es_pre_render_frame_cache_progress_status(inputs)
	if (locale === "zh-CN") return zh_cn2_pre_render_frame_cache_progress_status(inputs)
	if (locale === "ja") return ja_pre_render_frame_cache_progress_status(inputs)
	if (locale === "hi") return hi_pre_render_frame_cache_progress_status(inputs)
	if (locale === "pt-PT") return pt_pt2_pre_render_frame_cache_progress_status(inputs)
	return en_pre_render_frame_cache_progress_status(inputs)
});